import { axiosHelper } from 'Services/AxiosHelper';
import { organizationListBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';
import { OrganizationListModel } from 'Models';

const command = 'b2c.RIOrganizationList';

const organizationList = async (params: organizationListBodyData): Promise<OrganizationListModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default organizationList;
